<template>
  <div class="login-page">
    <app-navbar></app-navbar>
    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page section-image">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="col-lg-4 col-md-6 ml-auto mr-auto">
              <form @submit.prevent="login">
                <card type="login">
                  <h3 slot="header" class="header text-center">Login</h3>

                  <fg-input v-model="form.email" addon-left-icon="nc-icon nc-single-02"
                            placeholder="Email"></fg-input>

                  <fg-input v-model="form.password" addon-left-icon="nc-icon nc-key-25" placeholder="Password"
                            type="password"></fg-input>

                  <br>

    

                  <p-button native-type="submit" slot="footer" type="warning" round block class="mb-3">Login</p-button>
                </card>
                
                <div style="cursor:pointer;color:#fff;font-size:11px;text-align:left;margin-top:-15px;margin-left:10px;" @click='gotoForgetPassword'>Forgot Password</div>
              </form>
            </div>
          </div>
        </div>
        <app-footer></app-footer>
        <div class="full-page-background" style="background-image: url(static/img/background/background-3.jpg) "></div>
      </div>
    </div>
  </div>
</template>
<script>
  import { Card, Checkbox, Button } from 'src/components/UIComponents';
  import AppNavbar from './Layout/AppNavbar'
  import AppFooter from './Layout/AppFooter'
  import {UserService} from 'src/services/user.service'
  import swal from 'sweetalert2'

  export default {
    components: {
      Card,
      AppNavbar,
      AppFooter,
      [Checkbox.name]: Checkbox,
      [Button.name]: Button
    },
    methods: {
      toggleNavbar() {
        document.body.classList.toggle('nav-open')
      },
      closeMenu() {
        document.body.classList.remove('nav-open')
        document.body.classList.remove('off-canvas-sidebar')
      },
      gotoForgetPassword(){
      	this.$router.push( '/forget-password');
      },
      login(e) {
      	const vm = this;
        // handle login here
       
        //this.submitted = true;
          
        
        UserService.login(this.form.email, this.form.password)
                .then(function(response){
                
					if(response.data.success == 0){
						swal({
							  title: 'Oops!',
							  text: response.data.error,
							  type: 'error',
							  confirmButtonClass: 'btn btn-success btn-fill',
							  buttonsStyling: false
						})
							
					}
					else{
      	 		//alert("submitted: "+ response)
      	 				vm.$router.push( '/cs_dashboard')
      	 			}
      	 	});
      }
    },
    data() {
      return {
      	form:{
          email: '',
          password: ''
        }
      }
    },
    beforeDestroy() {
      this.closeMenu()
    }
  }
</script>
<style>
</style>
